import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.style.opacity = "0"
    this.element.style.transform = "translateY(30px)"
    this.element.style.transition = "opacity 0.6s ease-out, transform 0.6s ease-out"

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const delay = this.element.dataset.scrollRevealDelay || 0
            setTimeout(() => {
              this.element.style.opacity = "1"
              this.element.style.transform = "translateY(0)"
            }, delay)
            this.observer.unobserve(this.element)
          }
        })
      },
      { threshold: 0.1 }
    )
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
  }
}
